<div class="form-container">
  <form [formGroup]="customerForm">
    <div class="row">
      <div class="form-field phone-input-wrapper">
        <label for="firstName">First Name<span class="required">*</span></label>
        <div class="phone-input-container">
          <input
            type="text"
            class="form-control"
            id="firstName"
            formControlName="firstName"
            (keyup)="onFieldKeyup('firstName')"
            (input)="onFirstNameInput($event)"
            (blur)="hideNameDropdown()"
            placeholder="e.g. Emma"
            maxlength="100"
            [class.error]="
              customerForm.get('firstName')?.errors && customerForm.get('firstName')?.touched
            "
          />
          <!-- Name Search Dropdown -->
          <ng-container
            *ngTemplateOutlet="
              customerSearchDropdown;
              context: {
                showDropdown: showNameDropdown,
                results: nameSearchResults,
                isSearching: isSearchingCustomersByName,
              }
            "
          ></ng-container>
          <div class="error-message" *ngIf="getFieldError('firstName')">
            {{ getFieldError('firstName') }}
          </div>
        </div>
      </div>
      <div class="form-field">
        <label for="lastName">Last Name<span class="required">*</span></label>
        <div>
          <input
            type="text"
            class="form-control"
            id="lastName"
            formControlName="lastName"
            (keyup)="onFieldKeyup('lastName')"
            placeholder="e.g. Jackson"
            maxlength="100"
            [class.error]="
              customerForm.get('lastName')?.errors && customerForm.get('lastName')?.touched
            "
          />
          <div class="error-message" *ngIf="getFieldError('lastName')">
            {{ getFieldError('lastName') }}
          </div>
        </div>
      </div>
      <div class="form-field phone-input-wrapper">
        <label for="phoneNumber">Phone Number<span class="required">*</span></label>
        <div class="phone-input-container">
          <input
            type="tel"
            inputmode="tel"
            autocomplete="tel"
            class="form-control"
            id="phoneNumber"
            formControlName="phoneNumber"
            (keyup)="onFieldKeyup('phoneNumber')"
            (input)="onPhoneInput($event)"
            (blur)="hidePhoneDropdown()"
            placeholder="e.g.  (930) 947 2749"
            [attr.maxlength]="phoneMaxLength"
            [class.error]="
              customerForm.get('phoneNumber')?.errors && customerForm.get('phoneNumber')?.touched
            "
          />
          <!-- Phone Search Dropdown -->
          <ng-container
            *ngTemplateOutlet="
              customerSearchDropdown;
              context: {
                showDropdown: showPhoneDropdown,
                results: phoneSearchResults,
                isSearching: isSearchingCustomers,
              }
            "
          ></ng-container>
          <div class="error-message" *ngIf="getFieldError('phoneNumber')">
            {{ getFieldError('phoneNumber') }}
          </div>
        </div>
      </div>
      <div class="form-field">
        <label for="email">Email</label>
        <div>
          <input
            type="email"
            class="form-control"
            id="email"
            formControlName="email"
            (keyup)="onFieldKeyup('email')"
            placeholder="e.g. emma.j@gmail.com"
            maxlength="254"
            [class.error]="customerForm.get('email')?.errors && customerForm.get('email')?.touched"
          />
          <div class="error-message" *ngIf="getFieldError('email')">
            {{ getFieldError('email') }}
          </div>
        </div>
      </div>
    </div>
  </form>
</div>

<!-- Customer Search Dropdown Template (reused for name and phone search results) -->
<ng-template
  #customerSearchDropdown
  let-showDropdown="showDropdown"
  let-results="results"
  let-isSearching="isSearching"
>
  <div
    class="phone-search-dropdown"
    *ngIf="showDropdown && results.length > 0"
    (mousedown)="$event.preventDefault()"
  >
    <div
      class="dropdown-item"
      *ngFor="let customer of results; trackBy: trackByIndex"
      (click)="selectCustomerFromSearch(customer)"
    >
      <div class="customer-info">
        <div class="customer-name">{{ customer.first_name }} {{ customer.last_name || '' }}</div>
        <div class="customer-details">
          <span class="customer-phone">{{ customer.contact }}</span>
          <span class="customer-email" *ngIf="customer.email">{{ customer.email }}</span>
        </div>
      </div>
    </div>
  </div>
  <div class="phone-search-loading" *ngIf="isSearching">
    <div class="loading-spinner"></div>
    <span>Searching...</span>
  </div>
</ng-template>
